const locale = {
  placeholder: 'Wybierz godzinÄ',
};

export default locale;
